// Copying a URL from the browser address bar does not put a bare URL on the
// clipboard. Edge (and Chrome) offer two flavours: text/plain holds the URL,
// text/html holds <a href="URL">Page title</a>. A rich text editor always takes
// the richer flavour, so the title is what gets pasted and the URL — which only
// ever lived in the href — is silently dropped when the comment is persisted as
// plain text.
//
// Rewriting every anchor to its own href makes the URL the pasted text, which
// is what the author copied and what the render side can turn back into a link.
// Anchors whose text already is the href come out unchanged.
//
// Only http(s) links are rewritten. A relative href would resolve against our
// own origin and produce a URL the author never copied, and mailto:/tel: links
// carry no URL worth surfacing — those anchors are left for the editor to
// handle as before.
const REWRITABLE_HREF = /^https?:\/\//i;

export function replaceAnchorsWithHrefs(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const anchors = doc.querySelectorAll("a[href]");
  if (anchors.length === 0) return html;

  let rewritten = false;

  anchors.forEach((anchor) => {
    const href = anchor.getAttribute("href");
    if (!REWRITABLE_HREF.test(href)) return;

    anchor.replaceWith(doc.createTextNode(href));
    rewritten = true;
  });

  return rewritten ? doc.body.innerHTML : html;
}
